/* global Autodesk  */

var dbIdCount = 0;
var filteredDbIds=[]
class IsolateLayer extends Autodesk.Viewing.Extension {
    constructor(viewer, options) {
        super(viewer, options);
        options = options || {};
        this._filter = options.filter || ['2d', '3d'];
        this._group = null;
        this._button = null;
        this._isHidden = false;
    }

    load() {        
        console.log('IsolateLayer has been loaded.');
        return true;
    }

    unload() {
        if (this._group) {
            this._group.removeControl(this._button);
            if (this._group.getNumberOfControls() === 0) {
                this.viewer.toolbar.removeControl(this._group);
            }
        }
        console.log('IsolateLayer has been unloaded.');
        return true;
    }

    onToolbarCreated() {
        this._group = this.viewer.toolbar.getControl('IsolateLayerToolbar');
        if (!this._group) {
            this._group = new Autodesk.Viewing.UI.ControlGroup('IsolateLayerToolbar');
            this.viewer.toolbar.addControl(this._group);
        }
        this._button = new Autodesk.Viewing.UI.Button('IsolateLayerButton');
        this._button.onClick = this.onButtonClicked;
        this._button.setToolTip('Isolate Hazards');
        this._button.setIcon('icon-isolate-layer');
        this._group.addControl(this._button);
    }

    onButtonClicked=()=>{
        if(this._isHidden==true){
            this._isHidden=false;
            this.viewer.isolate([])
            return;
        }        
        var instanceTree = this.viewer.model.getData().instanceTree;
        var allDbIdsStr = Object.keys(instanceTree.nodeAccess.dbIdToIndex);
        var allDbIdsInt= allDbIdsStr.map(function(id) { return parseInt(id)});
        
        dbIdCount = allDbIdsInt.length

        allDbIdsInt.forEach((dbId)=>{
            this.viewer.model.getProperties(dbId, this.onSuccessGetProperties, this.ononErrorGetProperties)
        })
    }

    onSuccessGetProperties=(data)=>{
        --dbIdCount
        for(var i=0;i<data.properties.length;i++){
            if(data.properties[i].displayName=="Hazard"){
                filteredDbIds.push(data.dbId)
                break;
            }
        }
        if(dbIdCount===0){
            this.viewer.isolate(filteredDbIds)
            this._isHidden=true;
        }
    }

    ononErrorGetProperties=()=>{
        --dbIdCount
        if(dbIdCount===0){
            this.viewer.isolate(filteredDbIds)
            this._isHidden=true;
        }
    }
}

Autodesk.Viewing.theExtensionManager.registerExtension('IsolateLayer', IsolateLayer);